export enum SourceType {
  Keycloak = 'kc-user-id',
  Factsheet = 'factsheet-id',
  Visitor = 'visitor',
}